import * as LibModule from './lib.js';
(() => {

  const SELECTORS = {
    section: ".shopify-section--main-collection",
    productList: "product-list",
    pagination: ".collection__pagination",
    sentinel: "[data-infinite-scroll]"
  };

  const initInfiniteScroll = () => {
    const section = document.querySelector(SELECTORS.section);
    if (!section) return;

    const sentinel = section.querySelector(SELECTORS.sentinel);
    if (!sentinel || sentinel.dataset.infiniteScrollInitialized === "true") return;

    let productList = section.querySelector(SELECTORS.productList);
    let pagination = section.querySelector(SELECTORS.pagination);

    if (!productList || !pagination) return;

    sentinel.dataset.infiniteScrollInitialized = "true";

    let isLoading = false;

    const getNextUrl = () => {
      const nextLink = pagination?.querySelector('a[rel="next"]');
      return nextLink ? nextLink.href : null;
    };

    const observer = new IntersectionObserver(async (entries) => {
        
      if (!entries[0]?.isIntersecting || isLoading) return;

      const nextUrl = getNextUrl();
      if (!nextUrl) {
        observer.disconnect();
        return;
      }

      isLoading = true;
      observer.unobserve(sentinel);
      section.classList.add("is-loading");

      try {
        const response = await fetch(nextUrl, {
          headers: { "X-Requested-With": "XMLHttpRequest" }
        });

        if (!response.ok) {
          throw new Error("Failed to fetch next page");
        }

        const html = await response.text();
        const doc = new DOMParser().parseFromString(html, "text/html");
        const newSection = doc.getElementById(section.id);
        const newProductList = newSection?.querySelector(SELECTORS.productList);
        const newPagination = newSection?.querySelector(SELECTORS.pagination);

        if (newProductList) {
          Array.from(newProductList.children).forEach((item) => {
            productList.appendChild(item);
          });
        }

        if (newPagination) {
          pagination.replaceWith(newPagination);
        }

        productList = section.querySelector(SELECTORS.productList);
        pagination = section.querySelector(SELECTORS.pagination);

        LibModule.getVariant();
      } catch (error) {
      } finally {
        section.classList.remove("is-loading");
        isLoading = false;

        if (getNextUrl()) {
          observer.observe(sentinel);
        } else {
          observer.disconnect();
        }
      }
    }, { rootMargin: "600px 0px" });

    observer.observe(sentinel);
  };

  if (typeof window !== "undefined") {
    window.collectionInfiniteScrollInit = initInfiniteScroll;
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initInfiniteScroll);
  } else {
    initInfiniteScroll();
  }

  document.addEventListener("facet:update", () => {
    setTimeout(initInfiniteScroll, 0);
  });

  document.addEventListener("shopify:section:load", (event) => {
    if (event.detail?.sectionId) {
      const section = document.getElementById(`shopify-section-${event.detail.sectionId}`);
      if (section?.matches(SELECTORS.section)) {
        setTimeout(initInfiniteScroll, 0);
      }
    }
  });
})();
